/**
 * 主布局组件
 * 包含侧边栏、面包屑和页面内容
 */

import { Outlet, Link, useLocation } from 'react-router-dom'
import { History, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from './AppSidebar'
import { BreadcrumbNav } from './BreadcrumbNav'
import { ROUTES } from '@/constants/routes'

interface AppLayoutProps {
  /** 是否隐藏侧边栏（用于沉浸式页面） */
  hideSidebar?: boolean
}

export function AppLayout({ hideSidebar = false }: AppLayoutProps) {
  const location = useLocation()
  const isExamList = location.hash === '#/exam' || location.pathname === '/exam'

  return (
    <SidebarProvider defaultOpen={false}>
      <div className="flex h-screen w-full overflow-hidden">
        {!hideSidebar && <AppSidebar />}
        <main className="flex-1 flex flex-col overflow-hidden">
          {!hideSidebar && (
            <BreadcrumbNav
              actions={isExamList ? (
                <>
                  <Link to={ROUTES.EXAM_HISTORY}>
                    <Button variant="outline" size="sm" className="gap-1.5">
                      <History className="w-4 h-4" />
                      答题历史
                    </Button>
                  </Link>
                  <Link to={ROUTES.QB_EXTRACT}>
                    <Button size="sm" className="gap-1.5">
                      <Plus className="w-4 h-4" />
                      录入试卷
                    </Button>
                  </Link>
                </>
              ) : undefined}
            />
          )}
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
